import { Injectable } from '@angular/core';
import {
  IInventoryUniqueItem,
  MobileInventoryCountService,
} from '@ups/tool-tracker';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SearchSerialNumberService {
  constructor(public inventoryCountService: MobileInventoryCountService) {}

  search(searchString: string) {
    let filtered =
      this.inventoryCountService.selectedInventoryCount.relatedUniqueItems.filter(
        (item) => {
          return (
            item.itemId ===
            this.inventoryCountService.selectedInventoryCountDetail.itemId
          );
        }
      );

    filtered = filtered.filter((item1: IInventoryUniqueItem) => {
      return !this.inventoryCountService.selectedInventoryCountDetail.inventoryCountDetailUniqueItems.find(
        (item2) => {
          return item1.uniqueItemId === item2.uniqueItemId;
        }
      );
    });

    filtered = filtered.filter((item: IInventoryUniqueItem) => {
      return (
        item.itemIdentifier.toLowerCase().indexOf(searchString.toLowerCase()) >
        -1
      );
    });

    return of(filtered);
  }
}
